module.exports = __webpack_public_path__ + "static/media/pefin-onboarding-02.795ac346.png";